import { render, staticRenderFns } from "./mobile.vue?vue&type=template&id=ddab49aa&scoped=true&"
import script from "./mobile.vue?vue&type=script&lang=js&"
export * from "./mobile.vue?vue&type=script&lang=js&"
import style0 from "./mobile.vue?vue&type=style&index=0&id=ddab49aa&prod&scoped=true&lang=scss&"
import style1 from "./mobile.vue?vue&type=style&index=1&id=ddab49aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddab49aa",
  null
  
)

export default component.exports